import { buildPrivacyPolicy } from '@gjl/site-kit'
import { PRIVACY_OPTIONS } from '../legal-options'
import { LegalPage } from './LegalPage'

/**
 * Fairmeadow's privacy policy.
 *
 * ⚠️ THE SITE RAN WITHOUT ONE while collecting names, email addresses and free
 * text through two forms, setting GA4 cookies, and setting reCAPTCHA cookies —
 * the last of which the policy generator treats as an obligation to disclose.
 * Every other live site in the estate had a policy; this one was missed because
 * it is not part of the client fleet the seed walks.
 *
 * The prose is generated from `../legal-options.ts`, so a change to what this
 * site DOES is made there and reaches the page on the next deploy.
 */
export default function PrivacyPage() {
  return <LegalPage doc={buildPrivacyPolicy(PRIVACY_OPTIONS)} />
}
